import { useEffect, useState } from 'react';
import styled from 'styled-components';
import Input from '../Input/Input';
import i18n from '../../i18n';

export const DurationContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  min-width: 10rem;
  direction: ltr;
`;

interface Props {
  id: string;
  setDuration: (duration: string, name?: string) => void;
  value: number;
  isRequired: boolean;
  name?: string;
}

export const Duration: React.FC<Props> = ({
  id,
  setDuration,
  value = 0,
  isRequired = false,
  name,
}) => {
  const [hours, setHours] = useState<number | null>(
    () => Math.floor(value) ?? 0
  );
  const [minutes, setMinutes] = useState<number | null>(
    () => (value - Math.floor(value)) * 60 ?? 0
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      const customMinutes = +(minutes || 0) / 60 || 0;
      const customHour = hours || 0;
      const time = customHour + customMinutes;
      name ? setDuration(time.toString(), name) : setDuration(time.toString());
    }, 1000);

    return () => clearTimeout(timer);
  }, [hours, minutes]);

  return (
    <DurationContainer>
      <Input
        id={`hours-time-${id}`}
        label={i18n.t('hours', { ns: 'survey' }) as string}
        type={'number'}
        value={(hours || 0)?.toString()}
        placeholder={i18n.t('hours', { ns: 'survey' }) as string}
        onChange={(event) => {
          setHours(+event.target.value);
        }}
        required={isRequired}
        labelStyle={{ display: 'flex', justifyContent: 'center' }}
        wrapperStyle={{ width: '5.5rem' }}
        min={0}
      />
      <Input
        id={`minutes-time-${id}`}
        label={i18n.t('minutes', { ns: 'survey' }) as string}
        type={'number'}
        value={Math.round(minutes || 0).toString()}
        placeholder={i18n.t('minutes', { ns: 'survey' }) as string}
        onChange={(event) => {
          setMinutes(+event.target.value);
        }}
        required={isRequired}
        labelStyle={{ display: 'flex', justifyContent: 'center' }}
        wrapperStyle={{ width: '5.5rem' }}
        min={0}
        max={59}
      />
    </DurationContainer>
  );
};
